import React from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, Button, FormFeedback } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const WithdrawalSettings = props => {
  //meta title
  document.title = "Withdrawal & Referral Setting";
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ss_id: '',
      minimum_withdrawal: '',
      withdrawal_fee: '',
    },
    validationSchema: Yup.object({
      minimum_withdrawal: Yup.string()
        .matches(
          /^[#0-9.]+$/,
          'Please enter a valid minimum withdrawal!'
        )
        .required('Minimum Withdrawal is required'),
      withdrawal_fee: Yup.string()
        .matches(
          /^[#0-9.]+$/,
          'Please enter a valid withdrawal fee!'
        )
        .required('Withdrawal Fee is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ss_id: values.ss_id,
          minimum_withdrawal: values.minimum_withdrawal,
          withdrawal_fee: values.withdrawal_fee
        });
        const res = await postRequest('update-site-withdrawal-settings', jsonpar);
        if (res && res.code === 200) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      ss_id: '',
      referral_reward: '',
      invited_person_reward: '',
      max_referral_limit: '',
    },
    validationSchema: Yup.object({
      referral_reward: Yup.string()
        .matches(
          /^[#0-9.]+$/,
          'Please enter a valid referral reward!'
        )
        .required('Referral Reward is required'),
      invited_person_reward: Yup.string()
      .matches(
        /^[#0-9.]+$/,
        'Please enter a valid value!'
      )
      .required('Referral Reward is required'),
      max_referral_limit: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid max referral limit!'
        )
        .required('Max Referral Limit is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          ss_id: values.ss_id,
          referral_reward: values.referral_reward,
          invited_person_reward: values.invited_person_reward,
          max_referral_limit: values.max_referral_limit
        });
        const res = await postRequest('update-site-referral-settings', jsonpar);
        if (res && res.code === 200) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();
        
        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const handleLoadGetSiteSettings = async () => {
    const res = await getRequest('get-site-settings');
    if (res && res.code === 200) {
      let originalText = res.data;
      validation1.setValues({
        ...validation1.values,
        ss_id: originalText.ss_id,
        minimum_withdrawal: originalText.minimum_withdrawal,
        withdrawal_fee: originalText.withdrawal_fee
      });

      validation2.setValues({
        ...validation2.values,
        ss_id: originalText.ss_id,
        referral_reward: originalText.referral_reward,
        invited_person_reward: originalText.invited_person_reward,
        max_referral_limit: originalText.max_referral_limit
      });
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    handleLoadGetSiteSettings();
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Withdrawal & Referral Setting")} />

          <Row>
            <Col lg="12">
              <form>
                <Row>
                  <Col md={6} xs="12">
                    <Card>
                      <CardBody>
                        <Row>
                          <h3 className="cstm-title">Withdrawal Setting</h3>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Minimum Withdrawal :</Label>
                              <Input type="text" placeholder="Enter Minimum Withdrawal"
                                name="minimum_withdrawal"
                                onChange={validation1.handleChange}
                                onBlur={validation1.handleBlur}
                                value={validation1.values.minimum_withdrawal || ""}
                                invalid={
                                  validation1.touched.minimum_withdrawal && validation1.errors.minimum_withdrawal ? true : false
                                }
                              />
                              {validation1.touched.minimum_withdrawal && validation1.errors.minimum_withdrawal ? (
                                <FormFeedback type="invalid">{validation1.errors.minimum_withdrawal}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Withdrawal Fee(%) :</Label>
                              <Input type="text" placeholder="Enter Withdrawal Fee"
                                name="withdrawal_fee"
                                onChange={validation1.handleChange}
                                onBlur={validation1.handleBlur}
                                value={validation1.values.withdrawal_fee || ""}
                                invalid={
                                  validation1.touched.withdrawal_fee && validation1.errors.withdrawal_fee ? true : false
                                }
                              />
                              {validation1.touched.withdrawal_fee && validation1.errors.withdrawal_fee ? (
                                <FormFeedback type="invalid">{validation1.errors.withdrawal_fee}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <div className="text-left">
                          <Button type="button" color="primary"
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                            >Update</Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md={6} xs="12">
                    <Card>
                      <CardBody>
                        <Row>
                          <h3 className="cstm-title">Referral Setting</h3>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Inviter Reward :</Label>
                              <Input type="text" placeholder="Enter Inviter Reward"
                                name="referral_reward"
                                onChange={validation2.handleChange}
                                onBlur={validation2.handleBlur}
                                value={validation2.values.referral_reward || ""}
                                invalid={
                                  validation2.touched.referral_reward && validation2.errors.referral_reward ? true : false
                                }
                              />
                              {validation2.touched.referral_reward && validation2.errors.referral_reward ? (
                                <FormFeedback type="invalid">{validation2.errors.referral_reward}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Invited Person Reward :</Label>
                              <Input type="text" placeholder="Enter Invited Person Reward"
                                name="invited_person_reward"
                                onChange={validation2.handleChange}
                                onBlur={validation2.handleBlur}
                                value={validation2.values.invited_person_reward || ""}
                                invalid={
                                  validation2.touched.invited_person_reward && validation2.errors.invited_person_reward ? true : false
                                }
                              />
                              {validation2.touched.invited_person_reward && validation2.errors.invited_person_reward ? (
                                <FormFeedback type="invalid">{validation2.errors.invited_person_reward}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Max Referral Limit :</Label>
                              <Input type="text" placeholder="Enter Max Referral Limit"
                                name="max_referral_limit"
                                onChange={validation2.handleChange}
                                onBlur={validation2.handleBlur}
                                value={validation2.values.max_referral_limit || ""}
                                invalid={
                                  validation2.touched.max_referral_limit && validation2.errors.max_referral_limit ? true : false
                                }
                              />
                              {validation2.touched.max_referral_limit && validation2.errors.max_referral_limit ? (
                                <FormFeedback type="invalid">{validation2.errors.max_referral_limit}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <div className="text-left">
                          <Button type="button" color="primary"
                            id="submit2"
                            onClick={(e) => {
                              e.preventDefault();
                              validation2.handleSubmit();
                              return false;
                            }}
                            >Update</Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </form>

            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(WithdrawalSettings);
